





























import { Component, Watch } from 'vue-property-decorator';
import SaascadaVueDialog from '@/components/Shared/SaascadaVueDialog';
import DepositInstantAccessSettingsEdit from '@/components/Products/Forms/Deposit/DepositInstantAccessSettingsEdit.vue';
import { ProductDetailsModule } from '@/store/Products/ProductDetailsModule';

@Component({ name: 'DepositInstantAccessSettingsEditDialog', components: { DepositInstantAccessSettingsEdit } })
export default class extends SaascadaVueDialog {

    @Watch('dialog')
    async onDialogChanged(val: boolean) {
        if (val) {
            ProductDetailsModule.prepareProductViewModel();
        }
    }

    get productType() {
        return ProductDetailsModule.product.generalSettings.subType;
    }

    async save() {
        if (!(this.$refs.form as any).validateForm()) {
            return;
        }
        else {
            this.dialog = false;
            await ProductDetailsModule.editDepositInstantAccessSettings();
            await ProductDetailsModule.getHistory();
        }
    }

}
